import FormContainer from "./FormContainer";
import { Button } from "primereact/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { InputMask } from 'primereact/inputmask';
import If from "./If";
import useApi from "../hooks/ApiHook";

const countdownSeconds = 60;

const VerifyResetCode = () => {
	const navigate = useNavigate();
  const api = useApi();
  const [ params ] = useSearchParams();
  const [ email, setEmail ] = useState();
  const [ code, setCode ] = useState('');
  const [ finishedCountdown, setFinishedCountdown ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    setEmail(params.get('email'));
  }, [params]);

  const onFinishCountdown = () => {
    setFinishedCountdown(true);
  }

  const resendCode = () => {
    setFinishedCountdown(false);
    const username = params.get('username');
    api.post('change-password/request', { username });
  }

  const submit = async e => {
    e.preventDefault();
    try {
      setLoading(true);
      const result = await api.post('change-password/verify', { verificationCode: code, username: params.get('username') });
      navigate('./../new?uuid=' + result.data.uuid);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

	return (
		<FormContainer>
      <div className='text-3xl font-semibold text-black-alpha-90 mb-2'>
        Digite o código
      </div>
			<div className="mb-4 text-700">
        Um código foi enviado para o e-mail {email || 'cadastrado'}. Digite corretamente no campo abaixo
			</div>
      <form onSubmit={submit}>
        <div class="field">
          <label>Código recebido</label>
          <InputMask 
            className='w-full mb-1' 
            placeholder='XXXXXX' 
            mask="999999"
            slotChar="XXXXXX"
            required
            value={code}
            onChange={e => setCode(e.target.value)}/>
          <If condition={!finishedCountdown}>
            <small className="text-600">
              O código poderá ser reenviado novamente em <Countdown onFinish={onFinishCountdown} execute={!finishedCountdown}/>
            </small>
          </If>
        </div>
        <div class="field">
          <Button 
            className='w-full' 
            label='Continuar'
            loading={loading}
            disabled={!code || code.length < 6}/>
        </div>
        <div class="field">
          <Button 
            className='w-full' 
            label='Reenviar código' 
            severity="secondary"
            type='button'
            disabled={!finishedCountdown}
						onClick={resendCode}/>
        </div>
      </form>
    </FormContainer>
	);
}

function Countdown({ execute, onFinish }) {

  const [ seconds, setSeconds ] = useState(countdownSeconds);
  const [ finished, setFinished ] = useState(false);

  useEffect(() => {
    if (finished) {
      onFinish();
    }
  }, [finished]);

  useEffect(() => {
    if (execute) {
      setFinished(false);
      setSeconds(countdownSeconds);
    }
  }, [execute]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (finished) {
        return;
      }
      if (seconds === 0) {
        setFinished(true);
        return;
      }
      const newSeconds = seconds - 1;
      setSeconds(newSeconds);
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  return (
    <span>{seconds}</span>
  )
}

export default VerifyResetCode;